import {
  SET_PAGE_LOAD,
  CLEAR_PAGE_LOAD,
  PROGRESS_LOADING
} from '@/application/redux/types.d';

export function showLoading() {
  return {
    type: SET_PAGE_LOAD
  };
}

export function clearLoading() {
  return {
    type: CLEAR_PAGE_LOAD
  };
}

export function setProgressLoading(progress: any) {
  return {
    type: PROGRESS_LOADING,
    progress
  };
}